import { commonConstants } from '../CONSTANTS/tpi-common-constants';
import { StoreSelectedCompanyFields } from '../tpi-models/store/store-selected-company-fields.model';
import { ModifySelectedCompanyAction } from './reducer-actions.types';

export function updateSelectedCompanyFieldsReducer(state: StoreSelectedCompanyFields, action: ModifySelectedCompanyAction): StoreSelectedCompanyFields {
    if (action.type === commonConstants.STORE.MODIFY_SELECTED_COMPANY) {
        return action.payload;
    } else {
        return state;
    }
}